import React from "react";
import Styles from "./GiftReport.module.css";
import NoDataFound from "../../../common/NoDataFound";
import { convertToISTDateTime } from "../../../../../utils/DateTime.service";
import ShimmerLoader from "../../../../pages/ShimmerLoader/ShimmerLoader";
import currenyFormat from "../../../common/currentFormat";
import { Link } from "react-router-dom";

const GiftReport = ({ transactions, loading }) => {

  return (
    <>
      <div className='card-body'>
        <div className='table-responsive ticket-table'>
          <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
            <div className='table-responsive'>
              <table id='example' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Phone Number</th>
                    <th>Transaction Date</th>
                    <th>Status</th>
                    <th className="text-center">Gold Quantity</th>
                    <th className="text-center">Price per gram</th>
                    <th className="text-center">Total Amount</th>
                    <th>Reward Points</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        <ShimmerLoader />
                      </td>
                    </tr>
                  ) : transactions.length > 0 ? (
                    transactions.map((item, index) => (
                      <tr key={index}>
                        <td>
                        <Link className={`${Styles.link}`} to={`/transactions-details/${item.transaction_id}`}>{item.transaction_id || "--"}</Link>
                        </td>
                        <td>{item.phone ? item.phone : "--"}</td>
                        <td>{item.transaction_date ? convertToISTDateTime(item.transaction_date) : "--"}</td>
                        <td>
                          <span className='text-capitalize'>{item.status ? item.status : "--"}</span>
                        </td>
                        <td className="text-center">{item.gold_quantity ? `${item.gold_quantity} gm` : "--"}</td>
                        <td className="text-center">{item.price_per_gram ? currenyFormat(item.price_per_gram) : "--"}</td>
                        <td className="text-center">{item.total_amount ? currenyFormat(item.total_amount) : "--"}</td>
                        <td>{item.reward_points ? `${item.reward_points} gm` : "--"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className={`${Styles.no_hover}`}>
                      <td className={`fs-3 text-center`} colSpan={8}>
                        <NoDataFound width={450} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GiftReport;

// import React from "react";
// import Styles from "./GiftReport.module.css";
// import NoDataFound from "../../../common/NoDataFound";
// import { convertToISTDateTime } from "../../../../../utils/DateTime.service";

// const GiftReport = ({ transactions }) => {
//   return (
//     <>
//       <div className='card-body'>
//         <div className='table-responsive ticket-table'>
//           <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
//             <div className='table-responsive'>
//               <table id='example' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
//                 <thead>
//                   <tr>
//                     <th>Transaction ID</th>
//                     <th>Phone Number</th>
//                     <th>Transaction Date</th>
//                     <th>Status</th>
//                     <th>Gold Quantity</th>
//                     <th>Price per gram</th>
//                     <th>Total Amount</th>
//                     <th>Reward Points</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {transactions.length > 0 ? (
//                     transactions.map((item, index) => (
//                       <tr key={index}>
//                         <td>{item.transaction_id ? item.transaction_id : "--"}</td>
//                         <td>{item.phone ? item.phone : "--"}</td>
//                         <td>{item.transaction_date ? convertToISTDateTime(item.transaction_date) : "--"}</td>

//                         <td>
//                           <span className='text-capitalize'>{item.status ? item.status : "--"}</span>
//                         </td>
//                         <td>{item.gold_quantity ? `${item.gold_quantity} gm` : "--"}</td>
//                         <td>₹ {item.price_per_gram ? item.price_per_gram : "--"}</td>
//                         <td>₹ {item.total_amount ? item.total_amount : "--"}</td>
//                         <td>{item.reward_points ? `${item.reward_points} gm` : "--"}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr className={`${Styles.no_hover}`}>
//                       <td className={`fs-3 text-center`} colSpan={9}>
//                         <NoDataFound width={450} />
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default GiftReport;
